import { forwardRef } from "react";

import type { SVGIconProps } from "../types";

export const ProductIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = "currentColor", size = 20, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill={color}
        d="M4.02 3.266h11.667c.237 0 .435.08.595.24.16.16.24.358.239.593 0 .236-.08.434-.24.594a.797.797 0 0 1-.594.24H4.021a.804.804 0 0 1-.594-.24.81.81 0 0 1-.24-.594c0-.235.08-.433.24-.593a.81.81 0 0 1 .594-.24Zm0 13.333a.804.804 0 0 1-.593-.24.81.81 0 0 1-.24-.593v-4.167h-.145a.8.8 0 0 1-.646-.302.787.787 0 0 1-.167-.698l.833-4.166a.825.825 0 0 1 .292-.48.8.8 0 0 1 .52-.187h11.96a.8.8 0 0 1 .52.187c.153.125.25.285.292.48l.833 4.166a.786.786 0 0 1-.167.698.802.802 0 0 1-.645.302h-.146v4.167c0 .236-.08.434-.24.594a.803.803 0 0 1-.594.24.81.81 0 0 1-.593-.24.804.804 0 0 1-.24-.594v-4.167h-3.333v4.167c0 .236-.08.434-.24.594a.803.803 0 0 1-.594.24H4.021Zm.834-1.666h5v-3.334h-5v3.334Z"
      />
    </svg>
  ),
);

ProductIcon.displayName = "ProductIcon";
